import { combineReducers } from 'redux';
import postsReducer from './postsSlice';
import usersReducer from './usersSlice';
import commentsReducer from './commentsSlice';
import appsReducer from './appsSlice';
import assetsReducer from './assetsSlice';
import imagesReducer from './imagesSlice';
import categoriesReducer from './categoriesSlice';
import reportsReducer from './reportsSlice';
import bundlesReducer from './bundlesSlice';
import settingsReducer from './settingsSlice';

export default combineReducers({
  posts: postsReducer,
  users: usersReducer,
  comments: commentsReducer,
  apps: appsReducer,
  assets: assetsReducer,
  images: imagesReducer,
  categories: categoriesReducer,
  reports: reportsReducer,
  bundles: bundlesReducer,
  settings: settingsReducer,
})
